<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" layout='inline'
  :onFinish='pageSearchChange'>
    <a-form-item label="关键词" name='keyword'>
      <a-input v-model:value="search.keyword" style="width: 300px;" placeholder="请输入模版名称/内容进行搜索" />
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey="id" :columns='columns' :data-source='data'>
    <template v-slot:action="{ record }">
      <a-button type="primary" @click="choose(record)">
        选择
      </a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange"  :show-total="total => `总数: ${total} `" />
</template>
<script>
  import { getSmsTemplate } from '@/api/message'
  import { onMounted, reactive, toRefs,ref } from 'vue'
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 10,
    type: "",
    keyword: "",
    status:1
  };
  export default {
    setup(props, { emit }) {
      const state = reactive({
        listLoading: false,
        total:0,
        columns: [
          {
            title: "模板名称",
            dataIndex: "name",
            key: "name",
          },
          {
            title: "模板内容",
            dataIndex: "content",
            key: "content",
          },
          {
            title: "操作",
            key: "action",
            slots: { customRender: "action" },
            width: 120
          },
        ]
      })
      //初始化 分页信息和筛选项信息
      const search = ref({ ...defSearch });
      const data = ref([]);
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const initData = async (values) => {
        state.listLoading = true;
        let res = await getSmsTemplate(values).then((res) => res.data);
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
        state.listLoading = false;
      }
      onMounted(() => {
        initData(search.value)
      })
      // 选择模板
      const choose = (data) => {
        emit('success', data)
      }
      return {
        ...toRefs(state),
        pageCurrentChange,
        pageSizeChange,
        pageSearchChange,
        choose,
        search,
        data
      }
    }
  }
</script>